import { forwardRef, memo, Ref, RefObject, useEffect } from 'react';
import MagnifyGlass from '@/components/icons/MagnifyGlass';
import type { GeoLocationParams } from '@/models/Location';
interface Props {
  getLocation: (params: GeoLocationParams) => void;
  onFocus: VoidFunction;
  placeholder: string;
  disabled: boolean;
}
const LocationSearch = forwardRef(({
  getLocation,
  onFocus,
  placeholder,
  disabled
}: Props, ref: Ref<HTMLInputElement>) => {
  useEffect(() => {
    const autocomplete = new google.maps.places.Autocomplete((ref as RefObject<HTMLInputElement>).current as HTMLInputElement, {
      componentRestrictions: {
        country: 'in'
      },
      fields: ['formatted_address', 'geometry', 'place_id', 'address_components']
    });
    const onPlaceChange = () => {
      const {
        geometry,
        formatted_address,
        address_components,
        place_id
      } = autocomplete.getPlace();
      if (formatted_address && geometry?.location && address_components && place_id) {
        const {
          lat,
          lng
        } = geometry.location;
        const geocoder = new google.maps.Geocoder();
        geocoder.geocode({
          location: {
            lat: lat(),
            lng: lng()
          }
        }, (results, status) => {
          let postalCode = '';
          if (status === 'OK' && results?.[0]) {
            postalCode = results[0].address_components.find(c => c.types.includes('postal_code'))?.long_name || '';
            getLocation({
              formattedAddress: formatted_address,
              latLng: `${lat()},${lng()}`,
              placeId: place_id,
              addressComponents: results?.[0]?.address_components || address_components || [],
              postalCode: postalCode
            });
          }
        });
      }
    };
    const listener = autocomplete.addListener('place_changed', onPlaceChange);
    return () => {
      listener.remove();
    };
  }, [getLocation, ref]);
  return <div className="flex bg-white items-center border border-solid border-neutral-20 rounded-lg h-12">
        <span className="p-2">
          <MagnifyGlass className="stroke-current fill-transparent stroke-[1.5] h-6 w-6" />
        </span>
        <input autoFocus inputMode="text" type="text" ref={ref} className="bg-white mr-2 flex-auto rounded-lg border-none outline-none text-sm h-full" placeholder={placeholder} onFocus={onFocus} disabled={disabled} />
      </div>;
});
export default memo(LocationSearch);